export var ActionKeys;
(function (ActionKeys) {
    ActionKeys["ADD_NOTIFICATION"] = "TOASTER/ADD_NOTIFICATION";
})(ActionKeys || (ActionKeys = {}));
export const addNotification = (payload) => {
    return { type: ActionKeys.ADD_NOTIFICATION, payload };
};
//# sourceMappingURL=actions.js.map